export const convertirLista = (strLista) => {
  let uno = strLista.replace(",", " ").replace('"', "").replace("'", "");
  let regex = /[\r\n\x0B\x0C\u0085\u2028\u2029]+/g;
  return uno.replace(regex, ",");
};
